import {
  Checkbox,
  Group,
  type MantineSize,
  Text as MantineText,
  Title as MantineTitle,
  ScrollArea,
  type StyleProp,
  type TitleOrder,
} from "@mantine/core";
import type { PropsWithChildren, ReactNode } from "react";
import styles from "./CheckboxCard.module.css";

// TODO: Aaron review?
type CheckboxCardTitleProps = PropsWithChildren<{
  order?: TitleOrder;
  rightSection?: ReactNode;
}>;

function Title({ order = 5, children, rightSection }: CheckboxCardTitleProps) {
  return (
    <Group>
      <MantineTitle order={order}>{children}</MantineTitle>
      {rightSection}
    </Group>
  );
}
CheckboxCard.Title = Title;

type CheckboxCardTextProps = PropsWithChildren<{
  scrollHideDelay?: number;
  mah?: StyleProp<React.CSSProperties["maxHeight"]>;
}>;

function Text({ scrollHideDelay = 700, mah = 150, children }: CheckboxCardTextProps) {
  return (
    <Group>
      <ScrollArea.Autosize scrollHideDelay={scrollHideDelay} offsetScrollbars mah={mah} w="100%">
        <MantineText w="100%" className={styles.description}>
          {children}
        </MantineText>
      </ScrollArea.Autosize>
    </Group>
  );
}
CheckboxCard.Text = Text;

type CheckboxCardProps = PropsWithChildren<{
  radius?: MantineSize;
  value: string;
  h?: StyleProp<React.CSSProperties["height"]>;
}>;

export function CheckboxCard({ value, radius = "md", h = "100%", children }: CheckboxCardProps) {
  return (
    <Checkbox.Card className={styles.root} radius={radius} value={value} h={h}>
      <Group wrap="nowrap" align="flex-start" m="md" h={h}>
        <Checkbox.Indicator />
        <div>{children}</div>
      </Group>
    </Checkbox.Card>
  );
}
